/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LineStringGeometry
 */
export interface LineStringGeometry {
    /**
     * 
     * @type {string}
     * @memberof LineStringGeometry
     */
    type: LineStringGeometryTypeEnum;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof LineStringGeometry
     */
    coordinates: Array<Array<number>>;
}


/**
 * @export
 */
export const LineStringGeometryTypeEnum = {
    LineString: 'LineString'
} as const;
export type LineStringGeometryTypeEnum = typeof LineStringGeometryTypeEnum[keyof typeof LineStringGeometryTypeEnum];


/**
 * Check if a given object implements the LineStringGeometry interface.
 */
export function instanceOfLineStringGeometry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "coordinates" in value;

    return isInstance;
}

export function LineStringGeometryFromJSON(json: any): LineStringGeometry {
    return LineStringGeometryFromJSONTyped(json, false);
}

export function LineStringGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineStringGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function LineStringGeometryToJSON(value?: LineStringGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
    };
}

